export default {
	title: 'Espace <i>La santé de mon enfant</i>',
	soustitle: 'Sélectionnez un enfant pour accéder à son espace prévention.'
};
